import { is3pProductKey, type ProductKeys3P } from '../../constants/products';
import {
	SMARTLINKS_CONNECTOR_SOURCE,
	type ThirdPartyConfigsBootstrap,
} from '../../constants/schemas/3p-config';

interface isProductSmartlinkProps {
	productKey?: string; // loosely typed as string to accomodate for few cases which have this value as a string
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
}

/**
 * Determines whether a product is "connected" (i.e. the user has completed OAuth where required).
 * First-party products (not in thirdPartyConfigs) are always considered connected.
 *
 * For third-party products, userNeedsOAuth indicates whether user needs to authenticate:
 * - userNeedsOAuth: true → NOT connected (needs OAuth)
 * - userNeedsOAuth: false → IS connected (OAuth completed)
 */
export const isProductConnected = (
	productKey: string | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	if (!productKey) {
		return true;
	}
	const productConfig = thirdPartyConfigs[productKey as ProductKeys3P];
	if (!productConfig) {
		return true;
	}
	return productConfig.datasources?.some((ds) => !ds?.userNeedsOAuth) ?? false;
};

export const isProductSmartlink = ({
	productKey,
	thirdPartyConfigs,
}: isProductSmartlinkProps): boolean => {
	const product3PConfig =
		productKey && is3pProductKey(productKey) ? thirdPartyConfigs[productKey] : null;
	return (
		product3PConfig?.connectorSources?.length === 1 &&
		product3PConfig.connectorSources[0] === SMARTLINKS_CONNECTOR_SOURCE
	);
};
